// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBeZA1R7au8RVJniXwLJ3pp8XFHFuw2q8c",
  authDomain: "crypto-hunter-18b7d.firebaseapp.com",
  projectId: "crypto-hunter-18b7d",
  storageBucket: "crypto-hunter-18b7d.appspot.com",
  messagingSenderId: "300334694263",
  appId: "1:300334694263:web:e33ea35ff55e0c528f2b72",
};

export default firebaseConfig;
